<template>
  <div>
    <el-container>
      <el-main>
        <el-form :rules="rules" :model="currentButton" ref='currentButtonForm'>
          <el-row type="flex" justify="center">
            <el-col :span="18" style="max-width: 900px">
              <div class="menu-custom">
                <div class="menu-demo">
                  <div>
                    <div class="menu-demo-bottom">
                      <div class="keybord">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#iconjianpan"></use>
                        </svg>
                      </div>
                      <ul>
                        <li v-for='(button,index) in WeixinMenu.button' :key="index">
                          <div>
                            <div class="libutton" v-if='!button.sub_button || button.sub_button.length<=4' @click='addSubButton(index)'>添加菜单</div>
                            <div v-show="button.sub_button && button.sub_button.length > 0" v-for='(subButton,indexx) in button.sub_button' :key="indexx" @click="setCurrentButton(index * 6 + indexx + 1,subButton)" class="libutton">{{subButton.name ? subButton.name : '请输入菜单名称'}}</div>
                            <div class="libutton" @click="setCurrentButton(index * 6 ,button)">{{button.name ? button.name : '请输入菜单名称'}}</div>
                          </div>
                        </li>
                        <li v-if='WeixinMenu.button.length<=2' @click='addButton()' style="tex">
                          添加菜单
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="menu-container" v-if='currentButton.type'>
                  <div class="menu-title">
                    <div style="float:left"> 新增菜单</div>
                    <div style="float:right" @click='deleteCurrentButton()'>删除菜单</div>
                  </div>
                  <div class="menu-content">
                    <div v-if='currentButton && currentButton.sub_button && currentButton.sub_button.length >=1'>已为“{{currentButton.name}}”添加了{{currentButton.sub_button.length}}个子菜单，无法设置其他内容</div>
                    <div size="medium">
                      <el-form-item label="菜单名称:" prop='name'>
                        <el-input maxlength='8' show-word-limit v-model="currentButton.name"></el-input>
                      </el-form-item>
                    </div>
                    <div v-if='!(currentButton && currentButton.sub_button && currentButton.sub_button.length >=1)'>
                      <div>
                        <el-form-item label="菜单内容:">
                          <el-radio-group v-model="currentButton.buttonType" @change="changeButtonType">
                            <el-radio label='1'>发送消息</el-radio>
                            <el-radio label='2'>跳转网页</el-radio>
                            <el-radio label='3'>转人工</el-radio>
                            <!-- <el-radio label='4'>跳转小程序</el-radio> -->
                          </el-radio-group>
                        </el-form-item>
                      </div>
                      <div v-if="currentButton.buttonType === '1'">
                        <el-tabs v-model="activeTab" type="card" @tab-click="handleClick">
                        <!-- <el-tab-pane label="图文消息" name="first" >
                          <div class="image-text-block">
                            <svg class="icon icon-pic" aria-hidden="true">
                              <use xlink:href="#icontuwenxiaoxihuifu"></use>
                            </svg>
                          </div>
                          <div class="block-bottom">
                          <div>
                            <ul class="right-list">
                              <li>
                                <svg class="icon" aria-hidden="true">
                                  <use xlink:href="#icontable-delete"></use>
                                </svg>
                                删除
                              </li>
                              <li>
                                <svg class="icon" aria-hidden="true">
                                  <use xlink:href="#iconfabu"></use>
                                </svg>
                                保存并发送
                              </li>
                            </ul>
                          </div>
                        </div>
                        </el-tab-pane> -->
                        <el-tab-pane label="文字" name="first">
                          <div>
                            <el-form-item prop='key'>
                              <!-- <textarea class="textarea" v-model="currentButton.key"></textarea> -->
                              <el-input maxlength = '128' rows='7' placeholder="请输入内容" clearable='true' show-word-limit type="textarea" v-model="currentButton.key"></el-input>
                            </el-form-item>
                            <el-row type="flex" justify="space-between" class="textarea-bottom">
                              <!-- <div>
                                <svg class="icon" aria-hidden="true">
                                  <use xlink:href="#iconbiaoqing"></use>
                                </svg>
                              </div> -->
                              <div>
                                <!-- <span class="explain">还能输入600个字</span> -->
                              </div>
                            </el-row>
                          </div>
                        </el-tab-pane>
                      </el-tabs>
                    </div>
                    <div class="menu-other" v-if="currentButton.buttonType === '2'">
                      <div class="other-title">
                        跳转链接
                      </div>
                      <el-row class="other-content" type="flex" justify="center" align="middle">
                        <el-col :span="20">
                          <p class="other-explain">订阅者点击该子菜单会跳转到以下链接</p>
                            <el-form-item label="跳转链接:" prop='url'>
                              <el-input placeholder="http://" v-model="currentButton.url"></el-input>
                            </el-form-item>
                        </el-col>
                      </el-row>
                    </div>
                    <div class="menu-other" v-if="currentButton.buttonType === '3'">
                    </div>
                    <div class="menu-other" v-if="currentButton.buttonType === '4'">
                      <div class="other-title">
                        跳转链接
                      </div>
                      <el-row class="other-content" type="flex" justify="center" align="middle">
                        <el-col :span="20">
                          <p class="other-explain">订阅者点击该子菜单会跳转到以下链接</p>
                          <el-form size="medium">
                            <el-form-item label="小程序ID:" label-width="90px">
                              <el-input></el-input>
                              <el-tooltip class="item" content="暂无内容" placement="right">
                                <el-button
                                  type="text"
                                  size="small"
                                >
                                  <svg class="icon icon-warning" aria-hidden="true">
                                    <use xlink:href="#icontixing" />
                                  </svg>
                                </el-button>
                              </el-tooltip>
                            </el-form-item>
                            <el-form-item label="小程序路径:" label-width="90px">
                              <el-input></el-input>
                              <el-tooltip class="item" content="暂无内容" placement="right">
                                <el-button
                                  type="text"
                                  size="small"
                                >
                                  <svg class="icon icon-warning" aria-hidden="true">
                                    <use xlink:href="#icontixing" />
                                  </svg>
                                </el-button>
                              </el-tooltip>
                            </el-form-item>
                            <el-form-item label="备用网页:" label-width="90px">
                              <el-input placeholder="http://"></el-input>
                              <el-tooltip class="item" content="暂无内容" placement="right">
                                <el-button
                                  type="text"
                                  size="small"
                                >
                                  <svg class="icon icon-warning" aria-hidden="true">
                                    <use xlink:href="#icontixing" />
                                  </svg>
                                </el-button>
                              </el-tooltip>
                            </el-form-item>
                          </el-form>
                        </el-col>
                      </el-row>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-row type="flex" justify="center">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submit">保存</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </el-main>
    </el-container>

    <!-- <el-dialog
      width="480px"
      :visible.sync="artificialDialog"
      class="dialog-artificial"
    >
      <el-form >
        <el-form-item label="标题">
          <el-input placeholder="标题不能超过60个字符"></el-input>
        </el-form-item>
        <el-form-item label="封面">
          <el-upload>
            <div class="el-upload__tip">（大图片建议尺寸：900像素 * 500像素）</div>
            <el-row type="flex" justify="space-between" style="margin-left: -40px;">
              <el-button size="small" type="info">图片上传</el-button>
            </el-row>
          </el-upload>
        </el-form-item>
        <el-form-item label="摘要">
          <el-input type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="选择正文编辑方式" class="choice-content">
          <el-button style="width: 100%">秀米图文助手</el-button>
          <el-button style="width: 100%">链接到网页</el-button>
          <el-button style="width: 100%">手工编辑</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="center" style="margin-top: 10px">
        <el-button size="medium">预 览</el-button>
        <el-button type="primary" size="medium" @click="dialogVisible = false">保 存</el-button>
      </el-row>
    </el-dialog> -->
  </div>
</template>

<script>

export default {
  name: 'MenuConfig',
  data() {
    var validateName = (rule, value, callback) => {
      if (value === undefined || value === null || value === '') {
        callback(new Error('菜单名不能为空'))
      // eslint-disable-next-line no-control-regex
      } else if (value.replace(/[^\u0000-\u00ff]/g, 'aa').length > 8) {
        callback(new Error('仅支持中英文和数字，字数不超过4个汉字或8个字母'))
      } else {
        callback()
      }
    }
    var validateKey = (rule, value, callback) => {
      if (value === undefined || value === null || value === '') {
        callback(new Error('菜单值不能为空'))
      // eslint-disable-next-line no-control-regex
      } else if (value.replace(/[^\u0000-\u00ff]/g, 'aa').length > 128) {
        callback(new Error('菜单值不超过128字节'))
      } else {
        callback()
      }
    }

    var validateUrl = (rule, value, callback) => {
      if (value === undefined || value === null || value === '') {
        callback(new Error('url不能为空'))
      // eslint-disable-next-line no-control-regex
      } else if (value.replace(/(http|https):\/\/([\w.]+\/?)\S*/g, '').length !== 0) {
        callback(new Error('请输入正确的http或者https地址'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'first',
      WeixinMenu: {
        button: []
      },
      currentButton: {},
      currentButtonPosition: 0, // 0-17
      rules: {
        name: [
          { validator: validateName, trigger: 'blur' }
        ],
        key: [
          { validator: validateKey, trigger: 'blur' }
        ],
        url: [
          { validator: validateUrl, trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    appId: String,
    triggerWord: String,
    isThirdParty: Boolean
  },
  components: {

  },
  mounted() {
    this.getWeixinMenu()
  },
  methods: {
    createButton(name) {
      return {
        buttonType: '1',
        type: 'click',
        name: name,
        key: '',
        url: '',
        media_id: '',
        appid: '',
        pagepath: '',
        sub_button: []
      }
    },
    setCurrentButton(position, button) {
      if (position % 6 === 0 && (!this.createButton.sub_button || (this.createButton.sub_button && this.createButton.sub_button.length === 0))) {
        button.type = 'click'
      }
      const that = this
      this.$refs.currentButtonForm.validate((valid) => {
        if (valid) {
          that.currentButton = button
          that.currentButtonPosition = position

          switch (that.currentButton.type) {
            case 'click':
              if (that.currentButton.key !== that.triggerWord) {
                that.currentButton.buttonType = '1'
              } else {
                that.currentButton.buttonType = '3'
              }
              break
            case 'view':
              that.currentButton.buttonType = '2'
              break
            case 'miniprogram':
              that.currentButton.buttonType = '4'
              break

            default:
              break
          }
        } else {
          return false
        }
      })
    },
    addButton() {
      this.$refs.currentButtonForm.validate((valid) => {
        if (valid) {
          this.WeixinMenu.button.push(this.currentButton = this.createButton('菜单' + (this.WeixinMenu.button.length + 1)))
          this.currentButtonPosition = (this.WeixinMenu.button.length - 1) * 6
        } else {
          return false
        }
      })
    },
    addSubButton(index) {
      if (this.currentButtonPosition % 6 === 0) {
        if (this.WeixinMenu.button[index].sub_button === null) { this.WeixinMenu.button[index].sub_button = [] }
        this.WeixinMenu.button[index].sub_button.unshift(this.currentButton = this.createButton('子菜单' + (this.WeixinMenu.button[index].sub_button.length + 1)))
        this.currentButtonPosition = index * 6 + 1
        return
      }

      this.$refs.currentButtonForm.validate((valid) => {
        if (valid) {
          if (this.WeixinMenu.button[index].sub_button === null) { this.WeixinMenu.button[index].sub_button = [] }
          this.WeixinMenu.button[index].sub_button.unshift(this.currentButton = this.createButton('子菜单' + (this.WeixinMenu.button[index].sub_button.length + 1)))
          this.currentButtonPosition = index * 6 + 1
        } else {
          return false
        }
      })
    },
    deleteCurrentButton() {
      if (this.currentButtonPosition < 0) { return }
      if (this.currentButtonPosition % 6 === 0) { // 删除的是一级菜单
        this.WeixinMenu.button.splice(Math.floor(this.currentButtonPosition / 6), 1)

        var buttonIndex = this.currentButtonPosition / 6 - 1// 删除后要展示的button坐标
        if (buttonIndex < 0) {
          this.currentButton = {}
          this.currentButtonPosition = -1
        } else {
          this.currentButton = this.WeixinMenu.button[buttonIndex]
          this.currentButtonPosition = buttonIndex * 6
        }
      } else { // 删除的是子菜单
        this.WeixinMenu.button[Math.floor(this.currentButtonPosition / 6)].sub_button.splice(this.currentButtonPosition % 6 - 1, 1)// 删除选定菜单
        if (this.WeixinMenu.button[Math.floor(this.currentButtonPosition / 6)].sub_button.length > 0) { // 多于一个的子菜单,页面上子菜单从上往下数组坐标是01234递增的,所以删除一个子菜单时,currentButtonPosition不变的话,选中的当前菜单就会变成下一个
          this.currentButton = this.WeixinMenu.button[Math.floor(this.currentButtonPosition / 6)].sub_button[this.currentButtonPosition % 6 - 1]

          // 如果删除的是最下面那个子菜单,也就是子菜单数组最后面那个的话,那么currentButtonPosition就会数组越界
          if (this.currentButton === undefined) { this.currentButton = this.WeixinMenu.button[Math.floor(this.currentButtonPosition / 6)] }
        } else { // 只有一个子菜单
          this.currentButtonPosition--
          this.currentButton = this.WeixinMenu.button[Math.floor(this.currentButtonPosition / 6)]
        }
      }
    },
    changeButtonType(value) {
      value = this.currentButton.buttonType
      this.$forceUpdate()
      switch (value) {
        case '1':
          this.currentButton.type = 'click'
          break
        case '2':
          this.currentButton.type = 'view'
          break
        case '3':
          this.currentButton.type = 'click'
          this.currentButton.key = this.triggerWord
          break
        case '4':
          this.currentButton.type = 'miniprogram'
          break

        default:
          break
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event)
    },
    cancel() {
      this.$emit('cancel')
    },
    nextStep() {
      if (this.active++ > 2) this.active = 0
    },
    getWeixinMenu() {
      var that = this
      this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/getWeixinMenu', {
        params: {
          appId: this.appId,
          isThirdParty: that.isThirdParty
        }
      }).then(function(response) {
        if (response.data.code === 2000) {
          that.WeixinMenu = response.data.data
          that.WeixinMenu.button.forEach(button => {
            if (button.sub_button && button.sub_button.length > 0) {
              button.type = 'click'
              button.buttonType = '1'
            } else {
              // 没有子菜单的时候要给当前button设置buttonType,不然显示可能会不正确
              if (button.type === 'click') {
                button.buttonType = '1'
              } else if (button.type === 'view') {
                button.buttonType = '2'
              }
            }
          })
        } else {
          that.$message.error(response.data.msg)
          that.$emit('cancel')
        }
      }).catch(function(error) {
        console.log(error)
      })
    },
    submit() {
      if (this.WeixinMenu.button.length === 0) {
        this.$message.error('请至少添加一个菜单')
        return
      }

      var that = this
      this.$refs.currentButtonForm.validate((valid) => {
        if (valid) {
          this.$http.post(window.$envUtils('VUE_APP_BP_SERVICE') + '/channel/setWeixinMenu', {
            data: that.WeixinMenu,
            params: {
              appId: that.appId,
              isThirdParty: that.isThirdParty
            }
          }).then(function(response) {
            if (response.data.code === 2000) {
              that.$emit('cancel')
            } else {
              that.$message.error(response.data.msg)
            }
          }).catch(function(error) {
            console.log(error)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-header {
    padding: 0;
    margin-bottom: 0;
    .title {
      margin-bottom: 0;
    }
  }

  .max-block {
    max-width: 800px;
    h4 {
      text-align: center;
      font-size: 20px;
      color: #333;
      margin-bottom: 35px;
    }

    .el-form-item {
      ::v-deep .el-form-item__label {
        color: #333;
      }
      ::v-deep .el-form-item__content {
        .el-input,
        .el-textarea,
        .el-select {
          width: 75%;
          margin-right: 10px;
        }
        .el-select {
          .el-input {
            width: 100%;
          }
        }
        .el-row {
          width: 75%;
          .el-input,
          .el-textarea,
          .el-select {
            width: 100%;
            margin-right: 0;
          }
        }
      }
    }
    ::v-deep .el-form-item__content {
      .d-flex {
        display: flex;
        margin-bottom: 20px;
        .el-row {
          margin-right: 10px;
        }
        .el-button {
          & + .el-button {
            margin-left: 10px;
          }
        }
      }
    }
  }

  .menu-custom {
    display: flex;
    margin-top: 40px;
    margin-bottom: 50px;
    display: flex;
    justify-content: center;

    .menu-demo {
      position: relative;
      width: 290px;
      flex-basis: 290px;
      height: 518px;
      margin-right: 20px;
      border: 1px solid #e9e9e9;

      .menu-demo-bottom {
        display: flex;
        align-items: flex-end;
        position: absolute;
        bottom: 0;
        width: 100%;
        box-sizing: border-box;

        .keybord {
          flex-basis: 46px;
          display: flex;
          -webkit-box-pack: center;
          justify-content: center;
          -webkit-box-align: center;
          align-items: center;
          width: 34px;
          height: 42px;
          background-color: #f8f8f8;

          .icon {
            font-size: 24px;
          }
        }

        ul {
          display: flex;
          align-items: flex-end;
          width: calc(100% - 34px);

          li {
            width: 33.33%;
            height: 100%;
            line-height: 42px;
            background-color: #f8f8f8;
            border-left: 1px solid #e9e9e9;
            text-align: center;

            .libutton{
              border-top: 1px solid #e9e9e9;
            }
          }
        }
      }
    }
    .menu-container {
      flex: 1;
      border: 1px solid #e9e9e9;

      .menu-title {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        font-size: 14px;
        text-align: left;
        border-bottom: 1px solid #e9e9e9;
      }
      .menu-content {
        padding: 20px;

        .el-form-item {
          margin-bottom: 10px;
        }
        // tab
        .el-tabs--card {
          ::v-deep .el-tabs__header {
            margin-bottom: 0;

            .el-tabs__nav {
              &:first-child {
                margin-left: -1px;
              }
              .el-tabs__item {
                min-width: 100px;
                text-align: center;
                margin-right: 4px;
                border-radius: 5px 5px 0 0;
                background-color: #f7f7fa;
                color: #333;
                border: 1px solid transparent;
                border-bottom-color: #e9e9e9;
                &.is-active {
                  color: #337eff;
                  background-color: #fff;
                  border: 1px solid #e9e9e9;
                  border-bottom-color: transparent;
                }
              }
            }
          }
          // ::v-deep .el-tabs__content {
            // border-left: 1px solid #e9e9e9;
            // border-right: 1px solid #e9e9e9;
            // border-bottom: 1px solid #e9e9e9;
          // }
        }

        .block-bottom {
          height: 40px;
          line-height: 40px;
          border: 1px solid #e9e9e9;

          .right-list {
            float: right;

            li {
              float: left;
              border-left: 1px solid #e9e9e9;
              padding: 0 15px;
              color: #6b6b6b;
              cursor: pointer;

              &:hover {
                color: #337eff;
              }

              .icon {
                font-size: 16px;
                margin-right: 5px;
              }
            }
          }
        }
      }
    }
  }
  .el-tooltip__popper {
    max-width: 100px;
  }

  .menu-other {
    border: 1px solid #e9e9e9;
    // border-bottom: none;
    border-radius: 5px 5px 0 0;
    .other-title {
      height: 42px;
      line-height: 42px;
      padding: 0 15px;
      font-size: 14px;
      color: #333;
      background-color: #f7f7fa;
      border-radius: 5px 5px 0 0;
    }
    .other-content {
      min-height: 200px;
      padding: 10px 0;
      .other-explain {
        padding-left: 15px;
        margin-bottom: 15px;
        font-size: 14px;
      }
      ::v-deep .el-form-item {
        .el-input {
          width: 80%;
          margin-right: 10px;
        }
      }
    }
  }

  .dialog-artificial {
    ::v-deep .el-dialog__body {
      padding: 10px 40px 30px;
      .el-form-item {
        margin-bottom: 5px;
      }
      .el-upload {
        .el-upload__tip {
          margin-top: 0;
        }
      }
      .choice-content {
        .el-button {
          margin-bottom: 10px;
          & + .el-button {
            margin-left: 0;
          }
        }
      }
    }
  }

  .image-text-block {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 215px;

  .icon-pic {
    font-size: 118px;
    color: #e5e5e5;
  }
}
.icon {
  font-size: 16px;
  color: #5e656e;
}
.textarea {
  width: 100%;
  height: 180px;
  border: none;
  padding: 6px 10px;
  resize: none;
  outline: none;
}

.textarea-bottom {
  padding: 5px 10px 10px;

  .explain {
    color: #b2b2b2;
  }
}
</style>
